import axios from 'axios';
import {server_api_url} from '../config/constants';

class BeachesAPI {
  static getBeachDetails(id, language) {
    return axios.get(server_api_url + '/beaches/details', {
      crossDomain: true,
      params: {
        id: id,
        language: language,
      },
    });
  }

  static getBeaches(language) {
    return axios.get(server_api_url + '/beaches/all', {
      crossDomain: true,
      params: {
        language: language,
      },
    });
  }

  static getSeason() {
    return axios.get(server_api_url + '/beaches/season', {
      crossDomain: true,
      params: {},
    });
  }
}

export default BeachesAPI;
